module.exports = __webpack_public_path__ + "static/media/image 20.6827d954.png";